/**
 * Shows the gallery panel for the active direction service tab.
 *
 * @return {void}
 */
export function initDirectionServiceGalleries() {
	const wrapper = document.querySelector('[data-direction-service-galleries]');

	if (!wrapper) {
		return;
	}

	const panels = Array.from(
		wrapper.querySelectorAll('[data-direction-service-gallery-panel]')
	);

	if (!panels.length) {
		return;
	}

	/**
	 * @param {number|string} serviceId
	 * @return {void}
	 */
	const showForService = (serviceId) => {
		const normalizedId = String(serviceId);
		let hasPanel = false;

		panels.forEach((panel) => {
			const match =
				panel.getAttribute('data-direction-service-gallery-panel') ===
				normalizedId;

			panel.hidden = !match;

			if (match) {
				hasPanel = true;
			}
		});

		wrapper.hidden = !hasPanel;
	};

	document.addEventListener('lecardo-vein:direction-service:change', (event) => {
		const serviceId = event.detail?.serviceId;

		if (serviceId) {
			showForService(serviceId);
		}
	});
}

/**
 * Direction services block: tabs, hero scroll links, appointment modal handoff.
 *
 * @return {void}
 */
export function initDirectionServices() {
	const section = document.querySelector('[data-direction-services]');

	if (!section) {
		return;
	}

	const tabs = Array.from(
		section.querySelectorAll('[data-direction-services-tab]')
	);
	const panels = Array.from(
		section.querySelectorAll('[data-direction-services-panel]')
	);

	if (!tabs.length || !panels.length) {
		return;
	}

	/**
	 * @param {number} serviceId
	 * @return {void}
	 */
	const activateTab = (serviceId) => {
		const normalizedId = String(serviceId);

		tabs.forEach((tab) => {
			const isActive =
				tab.getAttribute('data-direction-services-tab') === normalizedId;

			tab.classList.toggle('is-active', isActive);
			tab.setAttribute('aria-selected', String(isActive));
		});

		panels.forEach((panel) => {
			const isActive =
				panel.getAttribute('data-direction-services-panel') === normalizedId;

			panel.classList.toggle('is-active', isActive);
			panel.hidden = !isActive;
		});

		section.dispatchEvent(
			new CustomEvent('lecardo-vein:direction-service:change', {
				bubbles: true,
				detail: { serviceId: Number(serviceId) },
			})
		);
	};

	/**
	 * @param {number} serviceId
	 * @return {void}
	 */
	const scrollToSection = (serviceId) => {
		const headerOffset = parseFloat(
			getComputedStyle(document.documentElement).getPropertyValue(
				'--header-mobile-offset'
			)
		);
		const offset = Number.isFinite(headerOffset) ? headerOffset : 72;
		const top =
			section.getBoundingClientRect().top + window.scrollY - offset - 20;

		window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
		activateTab(serviceId);
	};

	tabs.forEach((tab) => {
		tab.addEventListener('click', () => {
			const serviceId = tab.getAttribute('data-direction-services-tab');

			if (serviceId) {
				activateTab(Number(serviceId));
			}
		});
	});

	document.querySelectorAll('[data-direction-service-tab]').forEach((trigger) => {
		trigger.addEventListener('click', (event) => {
			event.preventDefault();

			const serviceId = trigger.getAttribute('data-direction-service-tab');

			if (serviceId) {
				scrollToSection(Number(serviceId));
			}
		});
	});

	section.querySelectorAll('[data-direction-services-book]').forEach((button) => {
		button.addEventListener('click', () => {
			const panel = button.closest('[data-direction-services-panel]');
			const serviceId = button.getAttribute('data-service-id') || '';
			const specialistSelect = panel?.querySelector(
				'[data-direction-services-specialist]'
			);
			const specialistId =
				specialistSelect instanceof HTMLSelectElement
					? specialistSelect.value
					: '';

			document.dispatchEvent(
				new CustomEvent('lecardo-vein:modal:open-request', {
					bubbles: true,
					detail: {
						modalId: 'appointment',
						serviceId: serviceId || null,
						specialistId: specialistId || null,
					},
				})
			);
		});
	});
}
